import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'
import { setSearchEvent } from 'actions/SearchActions'
import uuidV4 from 'lib/string/uuidV4Utils'

export default function useSearchEvent(searchKey: string): App.SearchData {
  const dispatch = useAppDispatch()

  const existingSearchSession = useAppSelector(state => state.search.searches[searchKey])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const newSearchId = useMemo(() => uuidV4(), [searchKey])

  useEffect(() => {
    if (!existingSearchSession) {
      dispatch(setSearchEvent(searchKey, { newSearchId }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey])

  const newSearchSession = useMemo(() => ({ searchId: newSearchId }), [newSearchId])

  return existingSearchSession ?? newSearchSession
}
